<template>

    <div>

        <div class="row" v-if="analise.id != null">

            <table class="table table-striped">
                <tbody>
                <tr>
                    <td><b>Remetente</b></td>
                    <td>{{ analise.remetente != null ? analise.remetente.nomerazao_social : 'Não informado'}}</td>
                    <td><b>Data de registro</b></td>
                    <td>{{ analise.data_registro | formatData }}</td>
                </tr>
                <tr>
                    <td><b>Tipo</b></td>
                    <td>{{ analise.tipo }}</td>
                    <td v-if="analise.tipo == 'SOLO'"><b>Análises solo</b></td>
                    <td v-if="analise.tipo == 'SOLO'">
                        <span v-if="analise.solo_quimica">Química</span>
                        <span v-if="analise.solo_fisica">Física</span>
                        <span v-if="analise.solo_extrato_saturacao">Extrato saturação</span>
                        <span v-if="analise.solo_metais_pesados">Metais pesados</span>
                    </td>
                </tr>
                <tr v-if="analise.tipo == 'SOLO'">
                    <td><b>Área HA</b></td>
                    <td>{{ analise.solo.area_ha }}</td>
                    <td><b>Localidade</b></td>
                    <td>{{ analise.solo.localidade }}</td>
                </tr>

                <tr v-if="analise.tipo == 'SOLO'">
                    <td><b>Matrícula</b></td>
                    <td>{{ analise.solo.matricula }}</td>
                    <td><b>Lote rural</b></td>
                    <td>{{ analise.solo.lote_rural }}</td>
                </tr>

                <tr v-if="analise.tipo == 'SOLO'">
                    <td><b>Referência cliente</b></td>
                    <td>{{ analise.solo.referencia_cliente }}</td>
                    <td><b>Altitude</b></td>
                    <td>{{ analise.solo.altitude }}</td>
                </tr>

                <tr v-if="analise.tipo == 'SOLO'">
                    <td><b>Longitude</b></td>
                    <td>{{ analise.solo.longitude }}</td>
                    <td><b>Latitude</b></td>
                    <td>{{ analise.solo.latitude }}</td>
                </tr>

                <tr v-if="analise.tipo == 'SOLO'">
                    <td><b>Profundidade inicial coleta</b></td>
                    <td>{{ analise.solo.profundidade_coleta_inicial }}</td>
                    <td><b>Profundidade final coleta</b></td>
                    <td>{{ analise.solo.profundidade_coleta_final }}</td>
                </tr>

                <tr v-if="analise.tipo == 'SEMENTE'">
                    <td><b>Amostra</b></td>
                    <td>{{ analise.semente.amostra }}</td>
                    <td><b>Lote</b></td>
                    <td>{{ analise.semente.lote }}</td>
                </tr>

                <tr v-if="analise.tipo == 'SEMENTE'">
                    <td><b>Safra</b></td>
                    <td>{{ analise.semente.safra }}</td>
                </tr>

                <tr v-if="analise.tipo == 'TECIDO'">
                    <td><b>Referência</b></td>
                    <td>{{ analise.tecido.referencia }}</td>
                </tr>


                <tr v-if="analise.tipo == 'FERTILIZANTE'">
                    <td><b>Nitrogênio</b></td>
                    <td>{{ analise.fertilizante.nitrogenio }}</td>
                </tr>

                <tr v-if="analise.tipo == 'FERTILIZANTE'">
                    <td><b>Fósforo</b></td>
                    <td>{{ analise.fertilizante.fosforo }}</td>
                </tr>

                <tr v-if="analise.tipo == 'FERTILIZANTE'">
                    <td><b>Potássio</b></td>
                    <td>{{ analise.fertilizante.potassio }}</td>
                </tr>

                <tr v-if="analise.tipo !== 'SEMENTE' && analise.tipo !== 'FERTILIZANTE'">
                    <td><b>Cultura</b></td>
                    <td>{{ analise.cultura.nome }}</td>
                </tr>

                <tr>
                    <td><b>Laudo para financiamento</b></td>
                    <td> {{ analise.laudo_financiamento ? 'Sim' : 'Não' }}</td>
                    <td><b>Data de pagamento</b></td>
                    <td>{{ analise.data_pagamento | formatData }}</td>
                </tr>
                <tr>
                    <td><b>Data previsão de conclusão</b></td>
                    <td>{{ analise.data_previsao_conclusao | formatData }}</td>
                    <td><b>Cidade</b></td>
                    <td>{{ analise.cidade.nome }}</td>
                </tr>

                <tr>
                    <td><b>Emails</b></td>
                    <td>
                        <span style="display:block;" v-if="analise.email != ''">{{ analise.email }}</span>
                        <span style="display:block;" v-if="analise.email2 != ''">{{ analise.email2 }}</span>
                        <span style="display:block;" v-if="analise.email3 != ''">{{ analise.email3 }}</span>
                    </td>
                    <td><b>Valor da análise</b></td>
                    <td>{{ analise.valor_amostra | formatMoney}}</td>
                </tr>

                <tr>
                    <td><b>Emitiu pedido?</b></td>
                    <td>
                        {{ analise.emitir_nota == 1 ? 'Sim' : 'Não' }}
                    </td>
                </tr>


                <tr>
                    <td><b>Emitiu apenas boleto?</b></td>
                    <td>
                        {{ analise.faturado == 1 && analise.emitir_nota == 0 ? 'Sim' : 'Não' }}
                    </td>

                    <td><b>Boleto para</b></td>
                    <td>
                        {{ analise.boleto }}
                    </td>
                </tr>

                <tr>
                    <td><b>Observações</b></td>
                    <td colspan="3"> {{ analise.observacao }}</td>
                </tr>

                </tbody>
            </table>

            <div v-if="analise.arrendatarios.length">
                <div class="title">Arrendatários</div>
                <table class="table table-bordered">
                    <thead>
                    <tr>
                        <th>Nome</th>
                        <th>CPF/CNPJ</th>
                    </tr>
                    </thead>
                    <tbody v-for="(arr) in analise.arrendatarios">
                    <tr>
                        <td>{{ arr.nomerazao_social }}</td>
                        <td>{{ arr.cpfcnpj }}</td>
                    </tr>
                    </tbody>
                </table>
            </div>

            <div v-if="analise.proprietarios.length">
                <div class="title">Proprietários</div>
                <table class="table table-bordered">
                    <thead>
                    <tr>
                        <th>Nome</th>
                        <th>CPF/CNPJ</th>
                    </tr>
                    </thead>
                    <tbody v-for="(prop) in analise.proprietarios">
                    <tr>
                        <td>{{ prop.nomerazao_social }}</td>
                        <td>{{ prop.cpfcnpj }}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div v-if="analise.data_resultado != null && analise.data_resultado != ''">
                <div class="title">Resultado</div>
                <table class="table table-bordered">
                    <tbody>
                        <tr v-if="analise.tipo == 'SEMENTE'">
                            <td>Germinação</td>
                            <td>{{ analise.semente.germinacao }}</td>
                            <td>Vigor</td>
                            <td>{{ analise.semente.vigor }}</td>
                        </tr>
                        <tr v-if="analise.tipo == 'SEMENTE'">
                            <td>Pureza</td>
                            <td>{{ analise.semente.pureza }}</td>
                        </tr>

                        <tr v-if="analise.tipo == 'TECIDO'">
                            <td>Nitrogênio (%)</td>
                            <td>{{ analise.tecido.nitrogenio }} - {{ analise.tecido.nitrogenio_avaliacao }}</td>
                            <td>Fósforo (%)</td>
                            <td>{{ analise.tecido.fosforo }} - {{ analise.tecido.fosforo_avaliacao }}</td>
                        </tr>

                        <tr v-if="analise.tipo == 'TECIDO'">
                            <td>Potássio (%)</td>
                            <td>{{ analise.tecido.potassio }} - {{ analise.tecido.potassio_avaliacao }}</td>
                            <td>Cálcio (%)</td>
                            <td>{{ analise.tecido.calcio }} - {{ analise.tecido.calcio_avaliacao }}</td>
                        </tr>

                        <tr v-if="analise.tipo == 'TECIDO'">
                            <td>Magnésio (%)</td>
                            <td>{{ analise.tecido.magnesio }} - {{ analise.tecido.magnesio_avaliacao }}</td>
                            <td>Enxofre (%)</td>
                            <td>{{ analise.tecido.enxofre }} - {{ analise.tecido.enxofre_avaliacao }}</td>
                        </tr>

                        <tr v-if="analise.tipo == 'TECIDO'">
                            <td>Zinco (mg/kg)</td>
                            <td>{{ analise.tecido.zinco }} - {{ analise.tecido.zinco_avaliacao }}</td>
                            <td>Manganês (mg/kg)</td>
                            <td>{{ analise.tecido.manganes }} - {{ analise.tecido.manganes_avaliacao }}</td>
                        </tr>

                        <tr v-if="analise.tipo == 'TECIDO'">
                            <td>Boro (mg/kg)</td>
                            <td>{{ analise.tecido.boro }} - {{ analise.tecido.boro_avaliacao }}</td>
                            <td>Sódio (mg/kg)</td>
                            <td>{{ analise.tecido.sodio }} - {{ analise.tecido.sodio_avaliacao }}</td>
                        </tr>

                        <tr v-if="analise.tipo == 'TECIDO'">
                            <td>Ferro (mg/kg)</td>
                            <td>{{ analise.tecido.ferro }} - {{ analise.tecido.ferro_avaliacao }}</td>
                        </tr>
                        <tr v-if="analise.tipo == 'SOLO' && analise.solo_quimica == 1">
                            <td>pH</td>
                            <td>{{ analise.solo.ph }}</td>
                            <td>SMP</td>
                            <td>{{ analise.solo.smp }}</td>
                        </tr>
                        <tr v-if="analise.tipo == 'SOLO' && analise.solo_quimica == 1">
                            <td>Matéria orgânica (%)</td>
                            <td>{{ analise.solo.materia_organica }}</td>
                            <td>Fósforo (P) (mg/L)</td>
                            <td>{{ analise.solo.fosforo }}</td>
                        </tr>
                        <tr v-if="analise.tipo == 'SOLO' && analise.solo_quimica == 1">
                            <td>Potássio (K) (mg/L) </td>
                            <td>{{ analise.solo.potassio }}</td>
                            <td>Fósforo Rem (P) (mg/L)</td>
                            <td>{{ analise.solo.fosforo_rem }}</td>
                        </tr>
                        <tr v-if="analise.tipo == 'SOLO' && analise.solo_quimica == 1">
                            <td>Cálcio (Ca ²+)</td>
                            <td>{{ analise.solo.calcio }}</td>
                            <td>Magnésio (mg ²+)</td>
                            <td>{{ analise.solo.magnesio }}</td>
                        </tr>
                        <tr v-if="analise.tipo == 'SOLO' && analise.solo_quimica == 1">
                            <td>Alumínio (Al ³+)</td>
                            <td>{{ analise.solo.aluminio }}</td>
                            <td>Hidrogênio + Al</td>
                            <td>{{ analise.solo.hidrogenio_al }}</td>
                        </tr>
                        <tr v-if="analise.tipo == 'SOLO' && analise.solo_quimica == 1">
                            <td>Sódio (Na)</td>
                            <td>{{ analise.solo.sodio }}</td>
                        </tr>
                        <tr v-if="analise.tipo == 'SOLO' && analise.solo_fisica == 1">
                            <td>Argila</td>
                            <td>{{ analise.solo.argila }}</td>
                            <td>Areia</td>
                            <td>{{ analise.solo.areia }}</td>
                        </tr>
                        <tr v-if="analise.tipo == 'SOLO' && analise.solo_fisica == 1">
                            <td>Silte</td>
                            <td>{{ analise.solo.silte }}</td>
                        </tr>
                        <tr v-if="analise.tipo == 'SOLO' && analise.solo_extrato_saturacao == 1">
                            <td>Condutividade (µs.cm-1)</td>
                            <td>{{ analise.solo.condutividade_saturacao }}</td>
                            <td>Alumínio (mg/L)</td>
                            <td>{{ analise.solo.aluminio_saturacao }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>

</template>

<script>
    import VcPesquisa from '@/components/Form/Pesquisa'
    import VcAdicionaPessoa from './AdicionarPessoas'
    import armazenaBoleto from './services/armazena_boleto'
    import armazenaPedido from "./services/armazenar_pedido";
    import aplicaPreco from './services/aplica_preco';

    export default {
        name: 'analises-detalhes',
        components: {
            VcPesquisa,
            VcAdicionaPessoa
        },
        data() {
            return {
                proprietarios: [],
                arrendatarios: [],
                analise: {
                    solo: {},
                    tecido: {},
                    semente: {}
                }
            }
        },

        mounted() {

            this.$store.dispatch('setTitle', 'Detalhes análise')

            return this.$http.get('api/analises/' + this.$route.params.id).then(res => {
                this.$set(this, 'analise', res.data)
                if (this.analise.semente == null) {
                    this.analise.semente = {};
                }
                if (this.analise.fertilizante == null) {
                    this.analise.fertilizante = {};
                }
                if (this.analise.solo == null) {
                    this.analise.solo = {};
                }
                if (this.analise.tecido == null) {
                    this.analise.tecido = {};
                }
            }).catch(error => {
                swal("Atenção", "Houve um problema ao mostrar detalhes da análise. <br><br>" + error.response.data.message, "warning")
                return this.$router.push({name: 'analises'})
            })
        }
    }
</script>

<style>

</style>